<template>
<div class="animated fadeIn" id="detailInsentifHRGA">
                <h3>Detail {{title}} - {{month}}</h3>
                <template v-if="editable == 2">
                    <detail-metric-non-edit 
                     :list-data="listDetail" 
                    />
                </template>
                <template v-else-if="editable==1">
                    <detail-metric-excel 
                        :list-data="listDetailExcel"
                        :option="options"
                    />
                </template>
            </div>
</template>
<script>
import DetailMetricNonEdit from './detail/DetailMetricNonEdit'
import DetailMetricExcel from './detail/DetailMetricExcel'
import {getService} from '@/services/get.service'
import moment from 'moment'
export default {
    components: {
        DetailMetricNonEdit,
        DetailMetricExcel
    },
    props: {
        url: {
            type: String,
            default: ''
        },
        option: {
      type: Object,
      default: () =>  ({
        year: '',
        month: '',
        label_id: '',
        branch_id: ''
      })
    }
    },
    created () {
        this.getDetail(this.url)
    },
    data() {
        return {
            editable: 0,
            listDetail: {},
            title: '',
            listDetailExcel: [],
            show: false,
            text: '',
            month: '',
            options: {
              year: '',
              month: '',
              label_id: '',
              branch_id: '',
            }
        }
    },
    watch: {
        url () {
            this.getDetail(this.url)
        },
        option () {
            this.options = this.option
        }
    },
    methods: {
        getDetail (url) {
            this.$store.commit('noLoad', true)
            this.editable = 3
            getService.getDataFromURL(url)
                .then(data => {
                    this.$store.commit('noLoad', false)
                    this.title = data.label
                    this.editable = data.editable ? 1 : 2
                    if (data.editable) {
                        // document.getElementById('card-detail').style.display = "none"
                        // this.listDetail = data.detail
                        this.listDetailExcel= data.detail.amount_detail ? data.detail.amount_detail : [['']]
                        this.show = true
                        this.options = this.option
                        this.month = moment(this.option.month , 'MM').format('MMMM') + this.option.year
                        this.options.amount = data.detail.amount || 0
                    } else {
                        this.listDetail = data.detail
                    }
                    document.getElementById('detailInsentifHRGA').scrollIntoView({
                        behavior: 'smooth' 
                    });
                })
        }
    },
}
</script>